import React from 'react';
import { ReactComponent as AirIcon } from 'design/assets/icons/air.svg';
import { ReactComponent as InternationalIcon } from 'design/assets/icons/international.svg';
import { ReactComponent as LodgingIcon } from 'design/assets/icons/lodging.svg';
import { ReactComponent as MealsIcon } from 'design/assets/icons/meals.svg';
import { ReactComponent as CarsIcon } from 'design/assets/icons/cars.svg';
import { ReactComponent as SafetyIcon } from 'design/assets/icons/safety-and-security.svg';
import { ReactComponent as PartnersIcon } from 'design/assets/icons/partners.svg';

const categoryIconMap = {
    airTravel: AirIcon,
    internationalTravel: InternationalIcon,
    lodging: LodgingIcon,
    mealsEntertainment: MealsIcon,
    rentalCars: CarsIcon,
    safetySecurity: SafetyIcon,
    travelPartners: PartnersIcon
};

export const getCategoryIcon = contentTypeId => {
    const Icon = categoryIconMap[contentTypeId];
    return Icon ? <Icon /> : null;
};


